import { ReactComponent as LogoIcon } from "../../Icons/logo.svg";
import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import {
  Box,
  IconButton,
  Typography,
  Grid,
  Stack,
  MenuItem,
  Menu,
  ListItemIcon,
} from "@mui/material";
import { ReactComponent as NewsMenuIcon } from "../../Icons/Admin/NewsMenuIcon.svg";
import { ReactComponent as AnnouncementMenuIcon } from "../../Icons/Admin/AnnouncementMenuIcon.svg";
import { ReactComponent as HostelIcon } from "../../Icons/Admin/HostelIcon.svg";
import UserCircleIcon from "../../Icons/UserCircleIcon.svg";
import { ReactComponent as UserIcon } from "../../Icons/UserIcon.svg";
import { ReactComponent as LogoutIcon } from "../../Icons/LogoutIcon.svg";
import { ReactComponent as DownArrowIcon } from "../../Icons/DownArrow.svg";
import { useSelector, useDispatch } from "react-redux";
import { removeData } from "../../Redux/Feature/AdminSlice";
import AssignmentIcon from "@mui/icons-material/Assignment";
import HailRoundedIcon from "@mui/icons-material/HailRounded";
import ListAltIcon from "@mui/icons-material/ListAlt";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import ChatIcon from "@mui/icons-material/Chat";
import ContactsIcon from "@mui/icons-material/Contacts";
import ViewCarouselIcon from "@mui/icons-material/ViewCarousel";
import TranslateIcon from "@mui/icons-material/Translate";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import ArticleIcon from "@mui/icons-material/Article";
import SecurityIcon from "@mui/icons-material/Security";
import GavelIcon from "@mui/icons-material/Gavel";
import PolicyIcon from "@mui/icons-material/Policy";
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { Collapse } from '@mui/material';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import ChecklistIcon from '@mui/icons-material/Checklist';


export default function Dashboard() {
  const navigate = useNavigate();
  const admin = useSelector((state) => state.AdminData.admin);
  const dispatch = useDispatch();
  const [adminData, setAdmin] = useState({
    userName: admin?.userName || "username",
  });
  const initialRenderBlock = localStorage.getItem("block")
    ? parseInt(localStorage.getItem("block"), 10)
    : 1;

    const [openDropdownId, setOpenDropdownId] = useState(null);

  const [renderBlock, setRenderBlock] = useState(initialRenderBlock);
  const [anchorlEl, setanchorlEl] = useState(null);
  const open = Boolean(anchorlEl);
  const [currentPath, setCurrentPath] = useState(
    () => localStorage.getItem("currentPath") || "/Admin"
  );

 
  const navItems = [
    {
      id : 1,
      name : 'Announcement',
      path: "/Admin",
      isDropDown : false,
      icon: <AnnouncementMenuIcon />,
    },
    {
      id : 2,
      name: "Carousel",
      path: "/Admin/carousel",
      isDropDown : false,
      icon: <ViewCarouselIcon />,
    },
    {
      id : 3,
      name: "News",
      path: "/Admin/NewsList",
      isDropDown : false,
      icon: <NewsMenuIcon />,
    },
    {
      id : 4,
      name : 'Hostel',
      isDropDown : true,
      icon : <HostelIcon />,
      subItems : [{
        id : 1,
        name: "Hostel List",
        path: "/Admin/Hostellist",
        icon: <FormatListBulletedIcon />,
      },
      {
        id : 2,
        name: "Hostel Applications",
        path: "/Admin/Application",
        icon: <AssignmentIcon />,
      },
      {
        id : 3,
        name: "Hostel Services",
        path: "/Admin/Services",
        icon: <HailRoundedIcon />,
      },
      {
        id : 4,
        name: "Hostel Charges",
        path: "/Admin/Charges",
        icon: <RequestQuoteIcon />,
      },
    ]
    },
    
    {
      id : 5,
      name : 'Dental',
      isDropDown : true,
      icon : <LocalHospitalIcon />,
      subItems : [{
        id : 1,
        name: "Dental List",
        path: "/Admin/dental",
        icon: <LocalHospitalIcon />,
      },
      {
        id : 2,
        name: "Dental Bookings",
        path: "/Admin/dental-bookings",
        icon: <LocalHospitalIcon />,
      },
      {
        id : 3,
        name: "Dental Content",
        path: "/Admin/dental-content",
        icon: <LocalHospitalIcon />,
      },
    ]
    },
    {
      id : 6,
      name : 'Services',
      isDropDown : true,
      icon : <HailRoundedIcon />,
      subItems : [{
        id : 1,
        name: "Common Services",
        path: "/Admin/common-services",
        icon: <HailRoundedIcon />,
      },
      {
        id : 2,
        name: "Booked Services",
        path: "/Admin/booked-services",
        icon: <HailRoundedIcon />,
      },
    ]
    },

    {
      id : 11,
      name: "Checklist Request",
      path: "/Admin/checklist",
      isDropDown : false,
      icon: <ChecklistIcon />,
    },
    {
      id : 12,
      name: "Student Report",
      path: "/Admin/student-report",
      isDropDown : false,
      icon: <AssignmentTurnedInIcon />,
    },
    {
      id : 7,
      name: "Users",
      path: "/Admin/users",
      isDropDown : false,
      icon: <PeopleAltIcon />,
    },
    {
      id : 8,
      name: "Checklist",
      path: "/Admin/Checklist-main",
      isDropDown : false,
      icon: <ListAltIcon />,
    },
    {
      id : 9,
      name: "Contact",
      path: "/Admin/contact-us",
      isDropDown : false,
      icon: <ContactsIcon />,
    },
    {
      id : 10,
      name : 'Translate',
      isDropDown : true,
      icon : <TranslateIcon />,
      subItems : [{
        id : 1,
        name: "About Us",
        path: "/Admin/aboutUs",
        icon: <TranslateIcon />,
      },
      {
        id : 2,
        name: "Terms and Conditions",
        path: "/Admin/terms",
        icon: <GavelIcon />,
      },
      {
        id : 3,
        name: "Policy Notice ",
        path: "/Admin/policyNotice",
        icon: <PolicyIcon />,
      },
    ]
    },
  ]

  useEffect(() => {
    navigate(currentPath);
  }, []);

  useEffect(() => {
    if (localStorage.getItem("token") == null) {
      navigate("/login");
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("currentPath", currentPath);
  }, [currentPath]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    dispatch(removeData());
    navigate("/login");
    setanchorlEl(null);
  };

  return (
    <>
      <Box
        sx={{
          boxShadow: "0px 8px 18px 0px rgba(0, 0, 0, 0.1)",
          width: "100%",
          height: "120px",
          backgroundColor: "#27bac4",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: { md: "60px", xs: "20px" },
          borderBottom: "3px solid white",
        }}
      >
        <Box onClick={() => navigate("/")}>
          <LogoIcon />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box sx={{ marginRight: "20px" }}>
            <Typography variant="h6_1" sx={{ color: "#FFF" }}>
              Admin Dashboard
            </Typography>
          </Box>
          <Box
            onClick={(e) => {
              setanchorlEl(e.currentTarget);
            }}
            px={1.3}
            sx={{
              width: "fit-content",
              height: "40px",
              borderRadius: "8px",
              paddding: "10px !important",
              backgroundColor: "#FFFFFF",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            <Box component="img" src={UserCircleIcon}></Box>
            <Typography variant="h9_3" color="#017BCC">
              {adminData.userName}
            </Typography>
            <DownArrowIcon fill="#017BCC" />
          </Box>
        </Box>
      </Box>
      <Box sx={{ height: "calc(100vh - 120px)", display: "flex" }}>
        <Box
          item
          lg={2.1}
          md={3}
          sm={4}
          xs={12}
          sx={{
            position: "static",
            height: "100%",
            borderRight: "2px solid rgb(229, 231, 235)",
            // px: { md: 4, xs: 4 },
            overflowY: "auto",
            width: "22%",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >

<Stack direction="column" gap={1} py={4}>
  {navItems.map((item) => {
    const isDropdownOpen = openDropdownId === item.id;

    // Highlight parent if any subItem matches currentPath
    const isSubItemActive = item.subItems?.some(sub => sub.path === currentPath);
    const isActive = currentPath === item.path || isSubItemActive;

    return (
      <Box key={item.id}>
        <Stack
          onClick={() => {
            if (item.isDropDown) {
              setOpenDropdownId(prev => (prev === item.id ? null : item.id));
            } else {
              navigate(item.path);
              setCurrentPath(item.path);
              setOpenDropdownId(null);
            }
          }}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{
            height: "45px",
            width: "100%",
            px: 2,
            borderLeft: isActive ? "2px solid rgba(26, 36, 97, 1)" : "",
            backgroundColor: isActive ? "rgba(245, 248, 250, 1)" : "",
            color: isActive ? "rgba(26, 36, 97, 1)" : "#737373",
            cursor: "pointer",
            ":hover": {
              transform: isActive ? "" : "scale(0.98)",
            },
          }}
        >
          <Stack direction="row" alignItems="center" gap={3.5}>
            {React.isValidElement(item.icon) &&
              React.cloneElement(item.icon, {
                style: {
                  width : '20px',
                  fill: isActive ? "rgba(26, 36, 97, 1)" : "#737373",
                  color: isActive ? "rgba(26, 36, 97, 1)" : "#737373",
                },
              })}
            <Typography sx={{fontWeight : 700}} variant="body1">{item.name}</Typography>
          </Stack>

          {item.isDropDown &&
            (isDropdownOpen ? (
              <ExpandLessIcon sx={{ color: isActive ? "rgba(26, 36, 97, 1)" : "#737373" }} />
            ) : (
              <ExpandMoreIcon sx={{ color: isActive ? "rgba(26, 36, 97, 1)" : "#737373" }} />
            ))}
        </Stack>

        {/* Submenu with animation */}
        <Collapse in={isDropdownOpen} timeout="auto" unmountOnExit>
          <Stack pl={5} py={1} spacing={1}>
            {item.subItems?.map((subItem) => {
              const isSubActive = currentPath === subItem.path;

              return (
                <Stack
                  key={subItem.id}
                  direction="row"
                  alignItems="center"
                  gap="15px"
                  
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent triggering parent
                    navigate(subItem.path);
                    setCurrentPath(subItem.path);
                  }}
                  sx={{
                    height: "40px",
                    cursor: "pointer",
                    padding : "10px",
                    color: isSubActive
                      ? "#27bac4" // Active submenu color
                      : "#737373",
                    backgroundColor: isSubActive
                      ? ""
                      : "",
                    borderRadius: "4px",
                    ":hover": {
                      backgroundColor: "rgba(230, 230, 250, 0.5)",
                    },
                  }}
                >
                  <Typography>
                    {React.isValidElement(subItem.icon) &&
                      React.cloneElement(subItem.icon, {
                        style: {
                          fill: isSubActive ? "#27bac4" : "#737373",
                          color: isSubActive ? "#27bac4" : "#737373",
                        },
                      })}
                  </Typography>
                  <Typography sx={{fontWeight : 600}} variant="body2">{subItem.name}</Typography>
                </Stack>
              );
            })}
          </Stack>
        </Collapse>
      </Box>
    );
  })}
</Stack>


        </Box>
        <Box
          sx={{
            // marginLeft: { lg: "17.5%", md: "25%", sm: "33%", xs: 0 },
            height: "calc(100vh - 120px)",
            width: "77%",
            overflowY: "auto",
            py: 4,
            px: 3,
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >
          <Box>
            <Outlet />
          </Box>
        </Box>
      </Box>
      <Menu
        open={open}
        anchorEl={anchorlEl}
        onClose={() => setanchorlEl(null)}
        sx={{ "& .MuiAvatar-root": { p: 2 }, mt: 1 }}
      >
        <MenuItem
          gap="10px"
          onClick={() => {
            setanchorlEl(null);
          }}
        >
          <ListItemIcon>
            <UserIcon />
          </ListItemIcon>
          <Typography color="#017BCC" variant="h7_3">
            Account
          </Typography>
        </MenuItem>
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          <Typography color="#017BCC" variant="h7_3">
            Logout
          </Typography>
        </MenuItem>
      </Menu>
    </>
  );
}
